module.exports = __webpack_public_path__ + "img-dashboard/register/complete-ilustration.f428907c.png";